import { Stack, Typography } from "@mui/material";
import React from "react";

type Props = {
  label: string;
  value: string | number | undefined;
};

export const ConfirmationInfoRow = ({ label, value }: Props) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" my={1} gap={2}>
    <Typography fontWeight="bold">{label}</Typography>
    <Typography noWrap>{value}</Typography>
  </Stack>
);
